import objectId from 'bson-objectid';
import api from '../../api';

export const dashboardsStartRequest = () => {
  return {
    type: 'DASHBOARDS_START_REQUEST'
  };
};

export const dashboardsEndRequest = () => {
  return {
    type: 'DASHBOARDS_END_REQUEST'
  };
};

export const getAllDashboardsSuccess = ({ data }) => {
  return {
    type: 'DASHBOARDS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllDashboardsError = error => {
  return {
    type: 'DASHBOARDS_GET_ALL_ERROR',
    payload: error
  };
};

export const addDashboardsSuccess = ({ data }) => {
  return {
    type: 'DASHBOARDS_ADD_SUCCESS',
    payload: data
  };
};

export const addDashboardsError = error => {
  return {
    type: 'DASHBOARDS_ADD_ERROR',
    payload: error
  };
};

export const editDashboardsSuccess = ({ data }) => {
  return {
    type: 'DASHBOARDS_EDIT_SUCCESS',
    payload: data
  };
};

export const editDashboardsError = error => {
  return {
    type: 'DASHBOARDS_EDIT_ERROR',
    payload: error
  };
};

export const removeDashboardsSuccess = id => {
  return {
    type: 'DASHBOARDS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeDashboardsError = error => {
  return {
    type: 'DASHBOARDS_REMOVE_ERROR',
    payload: error
  };
};

export const selectDefaultDashboardsSuccess = ({ data }) => {
  return {
    type: 'DASHBOARDS_SELECT_DEFAULT_SUCCESS',
    payload: data
  };
};

export const selectDefaultDashboardsError = error => {
  return {
    type: 'DASHBOARDS_SELECT_DEFAULT_ERROR',
    payload: error
  };
};

export const sidebarStateDashboards = state => {
  return {
    type: 'DASHBOARDS_SIDEBAR_STATE',
    payload: state
  };
};

export const enableTransitionDashboards = state => {
  return {
    type: 'DASHBOARDS_ENABLE_TRANSITION',
    payload: state
  };
};

export const transitionTimeDashboards = state => {
  return {
    type: 'DASHBOARDS_TRANSITION_TIME',
    payload: state
  };
};

export const memberTransitionDashboardsSuccess = ({ data }) => {
  return {
    type: 'DASHBOARDS_MEMBER_TRANSITION_SUCCESS',
    payload: data
  };
};

export const memberTransitionDashboardsError = error => {
  return {
    type: 'DASHBOARDS_MEMBER_TRANSITION_ERROR',
    payload: error
  };
};

export const setCurrentDashboard = payload => {
  return {
    type: 'DASHBOARDS_SET_CURRENT_DASH',
    payload
  };
};

export const addDashboards = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(dashboardsStartRequest());
      const response = await api().post('/api/dashboards', data);
      dispatch(addDashboardsSuccess(response));
      formReset();
    } catch (err) {
      dispatch(addDashboardsError(err));
    } finally {
      setTimeout(() => {
        dispatch(dashboardsEndRequest());
        submitBtn.disabled = false;
      }, 1000);
    }
  };
};

export const getAllDashboards = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(dashboardsStartRequest());
      const responseGet = await api().get('/api/dashboards', { params });
      if (responseGet.data.length) {
        dispatch(getAllDashboardsSuccess(responseGet));
      } else {
        const dash = {
          _id: objectId().str,
          user: JSON.parse(localStorage.getItem('user'))._id,
          name: 'Default',
          transition: true,
          selected: true,
          theme: 'default-theme',
          items: []
        };
        const responsePost = await api().post('/api/dashboards', dash);
        dispatch(
          getAllDashboardsSuccess({
            ...responsePost,
            data: [responsePost.data]
          })
        );
      }
    } catch (err) {
      dispatch(getAllDashboardsError(err));
    } finally {
      dispatch(dashboardsEndRequest());
    }
  };
};

export const editDashboards = data => {
  return async dispatch => {
    try {
      dispatch(dashboardsStartRequest());
      const id = data._id;
      const response = await api().put('/api/dashboards/' + id, data);
      dispatch(editDashboardsSuccess(response));
    } catch (err) {
      dispatch(editDashboardsError(err));
    } finally {
      setTimeout(() => {
        dispatch(dashboardsEndRequest());
      }, 1000);
    }
  };
};

export const removeDashboards = id => {
  return async dispatch => {
    try {
      dispatch(dashboardsStartRequest());
      await api().delete('/api/dashboards/' + id);
      dispatch(removeDashboardsSuccess(id));
      setTimeout(() => dispatch(dashboardsEndRequest()), 1000);
    } catch (err) {
      dispatch(removeDashboardsError(err));
      dispatch(dashboardsEndRequest());
    }
  };
};

export const selectDefaultDashboards = data => {
  return async dispatch => {
    try {
      dispatch(dashboardsStartRequest());
      const id = data._id;
      const response = await api().put('/api/dashboards/' + id, data);
      dispatch(selectDefaultDashboardsSuccess(response));
    } catch (err) {
      dispatch(selectDefaultDashboardsError(err));
    } finally {
      setTimeout(() => {
        dispatch(dashboardsEndRequest());
      }, 1000);
    }
  };
};

export const memberTransitionDashboards = data => {
  return async dispatch => {
    try {
      dispatch(dashboardsStartRequest());
      const id = data._id;
      const response = await api().put('/api/dashboards/' + id, data);
      dispatch(memberTransitionDashboardsSuccess(response));
    } catch (err) {
      dispatch(memberTransitionDashboardsError(err));
    } finally {
      setTimeout(() => {
        dispatch(dashboardsEndRequest());
      }, 1000);
    }
  };
};
